// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"e66b98e50a628802a962","883":"d5888ee980ff402b0d4e"}[chunkId] + ".js";
};